import React, { useState, useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import {
  getDoc,
  doc,
  onSnapshot,
  collection,
  getDocs,
  where,
  query,
} from "firebase/firestore";
import { db } from "./FirebaseConfig";
import LoadingSpinner from "./UserProfile/LoadingSpinner";
import ProfileShoppingLists from "./ShoppingList/ProfileShoppingLists";
import useActiveAccordianStore from "./StatesStore/ActiveAccordian";
import { UserAuth } from "./Context";

const ShoppingLists6 = ({ userData }) => {
  console.log("userData in ShoppingLists6", userData);
  // My Shopping list Data
  const [shoppingListData, setShoppingListData] = useState(null);
  // Invited ShoppingList Data
  const [invitedshoppingListData, setInvitedShoppingListData] = useState([]);
  // Current Selected Category
  const [mergedShoppingListData, setMergedShoppingListData] = useState([]);
  const { activeAccordian, setActiveAccordian } = useActiveAccordianStore();
  const { user } = UserAuth();
  // const activeBrands = useActiveBrandsStore((state) => state.activeBrands);
  const location = useLocation();
  // const [activeAccordion, setActiveAccordion] = useState([]);
  const [loading, setLoading] = useState(true);
  const [inviteListLoading, setInviteListLoading] = useState(true);
  const queryParams = new URLSearchParams(location.search);
  const listId = queryParams.get("listId");
  const isCurrentUserProfile = user?.uid === userData?.userId;

  useEffect(() => {
    if (listId) {
      setActiveAccordian([listId]);
    }
  }, [listId]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [activeAccordian]);

  useEffect(() => {
    const fetchShoppingLists = async () => {
      if (!userData) return;
      setLoading(true);
      const userRef = doc(db, "users", userData?.userId);
      const shoppingListRef = collection(userRef, "shoppingList");

      let productUnsubscribes = [];
      const unsubscribe = onSnapshot(shoppingListRef, async (snapshot) => {
        try {
          const shoppingListPromises = snapshot.docs.map(async (document) => {
            const shoppingList = document.data();
            const dateCreated =
              shoppingList.dateCreated?.seconds || new Date().getTime() / 1000;
            const lastUpdated =
              shoppingList.lastUpdated?.seconds || new Date().getTime() / 1000;

            const productRef = collection(
              shoppingListRef,
              document.id,
              "products"
            );
            const productUnsubscribe = onSnapshot(
              productRef,
              (productSnapshot) => {
                const products = productSnapshot.docs.map((productDoc) => ({
                  id: productDoc.id,
                  ...productDoc.data(),
                }));

                setShoppingListData((prevData) => {
                  const updatedData = prevData?.map((list) => {
                    if (list.name === document.id) {
                      return { ...list, products };
                    }
                    return list;
                  });
                  return updatedData?.sort(
                    (a, b) =>
                      b.products.length - a.products.length ||
                      b.dateCreated - a.dateCreated
                  );
                });
              }
            );

            productUnsubscribes.push(productUnsubscribe);

            const productSnapshot = await getDocs(productRef);
            const products = productSnapshot.docs.map((productDoc) => ({
              id: productDoc.id,
              ...productDoc.data(),
            }));

            return {
              ...shoppingList,
              id: document.id,
              name: shoppingList.listName,
              dateCreated,
              lastUpdated,
              products,
              userId: userData?.userId,
              ownerId: userData?.userId,
              listId: shoppingList.listId,
              // sizes: shoppingList.sizes,
              visibility: shoppingList.visibility,
              type: isCurrentUserProfile ? "myList" : "otherList",
            };
          });

          const shoppingListDataArray = await Promise.all(shoppingListPromises);
          shoppingListDataArray.sort((a, b) =>
            // b.products.length - a.products.length ||
            b.lastUpdated && a.lastUpdated
              ? b.lastUpdated - a.lastUpdated || a.dateCreated - b.dateCreated
              : a.dateCreated - b.dateCreated
          );
          setShoppingListData(shoppingListDataArray);
          setLoading(false);
        } catch (error) {
          console.error(error);
        } finally {
          setLoading(false);
        }
      });

      return () => {
        unsubscribe();
        productUnsubscribes.forEach((unsubscribe) => unsubscribe());
      };
    };

    const fetchInvitedShoppingLists = async () => {
      if (!userData) return;

      const invitedListRef = collection(
        db,
        "users",
        userData?.userId,
        "invitedList"
      );
      const invitedListUnsubscribes = [];

      const unsubscribe = onSnapshot(invitedListRef, async (snapshot) => {
        try {
          setInviteListLoading(true);
          const invitedLists = snapshot.docs.map((doc) => ({
            listId: doc.id,
            userId: doc.data().userId,
            role: doc.data().role,
          }));

          const testShoppingLists = await Promise.all(
            invitedLists.map(async ({ listId, userId, role }) => {
              const shoppingListRef = collection(
                db,
                "users",
                userId,
                "shoppingList"
              );
              const q = query(shoppingListRef, where("listId", "==", listId));
              const querySnapshot = await getDocs(q);

              if (querySnapshot.empty) return null;

              const shoppingListSnapshot = querySnapshot.docs[0];
              const shoppingListData = shoppingListSnapshot.data();

              const productRef = collection(
                shoppingListRef,
                shoppingListSnapshot.id,
                "products"
              );
              const productUnsubscribe = onSnapshot(
                productRef,
                (productSnapshot) => {
                  const products = productSnapshot.docs.map((productDoc) => ({
                    id: productDoc.id,
                    ...productDoc.data(),
                  }));

                  setInvitedShoppingListData((prevData) => {
                    const updatedData = prevData.map((list) => {
                      if (list.name === shoppingListSnapshot.id) {
                        return { ...list, products };
                      }
                      return list;
                    });
                    return updatedData;
                  });
                }
              );

              invitedListUnsubscribes.push(productUnsubscribe);

              const productSnapshot = await getDocs(productRef);
              const products = productSnapshot.docs.map((productDoc) => ({
                id: productDoc.id,
                ...productDoc.data(),
              }));

              return {
                id: shoppingListSnapshot.id,
                name: shoppingListSnapshot.data().listName,
                dateCreated:
                  shoppingListData.dateCreated?.seconds ||
                  new Date().getTime() / 1000,
                products,
                listId: shoppingListData.listId,
                // sizes: shoppingListData.sizes,
                userId: userId,
                ownerId: userId,
                role: role,
                lastUpdated:
                  shoppingListData.lastUpdated?.seconds ||
                  new Date().getTime() / 1000,
                visibility: shoppingListData.visibility,
                type: "invitedList",
              };
            })
          );

          let filteredShoppingLists = testShoppingLists.filter(
            (list) => list !== null
          );

          await Promise.all(
            filteredShoppingLists.map(async (list) => {
              const userRef = doc(db, "users", list?.userId);
              const userDoc = await getDoc(userRef);
              const userCompleteData = userDoc?.data();
              list.userName = userCompleteData?.userName;
              list.photo = userCompleteData?.photo;
            })
          );

          const urlListId = location.pathname.split("/").pop();
          if (urlListId && urlListId !== "inviteLists") {
            filteredShoppingLists.sort((a, b) => {
              if (a.listId === urlListId) return -1;
              if (b.listId === urlListId) return 1;
              return (
                b.lastUpdated - a.lastUpdated || a.dateCreated - b.dateCreated
              );
            });
          } else {
            filteredShoppingLists.sort(
              (a, b) =>
                b.lastUpdated - a.lastUpdated || a.dateCreated - b.dateCreated
            );
          }

          setInvitedShoppingListData(filteredShoppingLists);
          setInviteListLoading(false);
        } catch (error) {
          console.error(error);
        } finally {
          setInviteListLoading(false);
        }
      });

      return () => {
        unsubscribe();
        invitedListUnsubscribes.forEach((unsubscribe) => unsubscribe());
      };
    };
    document.body.scrollIntoView({ behavior: "smooth" });
    document.body.scrollTo(0, 0);
    // setLoading(true);
    fetchShoppingLists();
    if (isCurrentUserProfile) {
      fetchInvitedShoppingLists();
    }
    // setLoading(false);
  }, [userData]);
  useEffect(() => {
    if (
      Array.isArray(shoppingListData) &&
      Array.isArray(invitedshoppingListData)
    ) {
      const merged = [...shoppingListData, ...invitedshoppingListData];

      merged.sort((a, b) => b.lastUpdated - a.lastUpdated);

      setMergedShoppingListData(merged);
    }
  }, [shoppingListData, invitedshoppingListData]);

  if (loading || inviteListLoading) {
    return <LoadingSpinner />;
  }
  return (
    <>
      {/* <div className="col-md-8 col-lg-6 vstack gap-3 text-body mt-0 mt-lg-5 px-3 px-lg-0 me-2"> */}
      <div className="vstack text-body px-0 m-0 rounded-0">
        <style jsx>
          {`
            .linkStyle {
              font-family: Inter;
              font-size: 20px;
              line-height: 100%;
              text-align: center;
              display: inline-block;
              padding-bottom: 6px;
            }
          `}
        </style>
        <Routes>
          <Route
            path="/"
            element={
              <ProfileShoppingLists
                shoppingListData={mergedShoppingListData}
                setShoppingListData={setMergedShoppingListData}
                activeAccordion={activeAccordian}
                setActiveAccordion={setActiveAccordian}
                loading={loading}
                setLoading={setLoading}
              />
            }
          />
        </Routes>
      </div>
    </>
  );
};

export default ShoppingLists6;
